import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=7622b9ec&scoped=true&"
import script from "./Gift.vue?vue&type=script&lang=js&"
export * from "./Gift.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&id=7622b9ec&scoped=true&lang=css&"
import style1 from "./Gift.vue?vue&type=style&index=1&id=7622b9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622b9ec",
  null
  
)

export default component.exports